import request from '@/utils/request'

export function list(query) {
    return request({
        url: '/accountRecord/list',
        method: 'post',
        data:query
    })
}

export function info(id) {
    return request({
        url: '/accountRecord/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/accountRecord/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/accountRecord/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/accountRecord/delete',
        method: 'post',
        data
    })
}

export function downLoad(query) {
    let url = '/accountRecord/download'
    let config = {
        responseType: 'arraybuffer',
    }
    return request.post(url,query,config)
}

